import { render, staticRenderFns } from "./bdd-violations-register.vue?vue&type=template&id=6e6c5976"
import script from "./bdd-violations-register.vue?vue&type=script&lang=js"
export * from "./bdd-violations-register.vue?vue&type=script&lang=js"
import style0 from "./bdd-violations-register.vue?vue&type=style&index=0&id=6e6c5976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports